import { type ChangeEvent, type ComponentProps, useCallback } from 'react'

import { TextField } from '@/components/ui/text-field.tsx'
import type { ManagedField } from '@/modules/message/components/editor/fields/managed-field'
import { classNames } from '@/utils/helpers'

export type MessagePriceSelectorProps = ComponentProps<'div'> & {
  field: ManagedField<number>
}

export const MessagePriceSelector = (props: MessagePriceSelectorProps) => {
  const { className, field, ...rest } = props

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value

      if (value.includes('.')) {
        value = value.substring(0, value.indexOf('.') + 3)
      }

      field.onChange(value ? Number(value) : null)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  return (
    <div
      {...rest}
      className={classNames('flex flex-col gap-1.5', className)}
    >
      <label className="flex items-center gap-2 text-sm font-medium text-text-default">
        Price
      </label>
      <TextField
        {...field}
        testId="message-price-selector"
        onChange={handleChange}
        name="price"
        type="number"
        step={0.01}
        prefix={<span className="text-secondary-300">$</span>}
        placeholder="Enter Price"
        className="h-[40px]"
      />
      {field.error && (
        <span className="text-xs font-medium text-danger-default">
          {field.error.message}
        </span>
      )}
    </div>
  )
}
